import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgPipesModule } from 'ngx-pipes';
import { CommonServicesModule } from 'common-services';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatStepperModule } from '@angular/material/stepper';
import { HttpClientModule } from '@angular/common/http';

import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as fromApp from './store/app.reducer';

import { AppConfig } from '../config/app-config';
import { LmsActivitiesProcessFlowComponent } from '../components/lms-activities-process-flow/lms-activities-process-flow.component';
// import * as PipConfirmationComponent from '../components/pip-mailing/confirmation/confirmation.component';
import * as LmsConfirmationComponent from '../components/lms-activities-process-flow/confirmation/confirmation.component';
import { FooterComponent } from '../components/nav/footer/footer.component';
import { NavbarComponent } from '../components/nav/navbar/navbar.component';
import { LmsEffects } from '../components/lms-activities-process-flow/store/lms-activities.effects';
import { ErrorModalComponent } from '../error-modal/error-modal.component';
import { AuthEffects } from '../auth/store/effects/auth.effects';
import { ClaimCmeCeStoreModule } from '../components/claim-cme-ce/store/claim-cme-ce-store.module';
import { ProgressStoreModule } from './store/progress-store';
import { LoadingStoreModule } from './store/loading-store';
import { LoadingIndicatorComponent } from '../loading-indicator/loading-indicator.component';
import { ProgressIndicatorComponent } from '../progress-indicator/progress-indicator.component';
import { ContactCapDirective } from './directives/contact-cap.directive';
import { TooltipModule } from './components/tooltip/tooltip.module';

export function initConfig(config: AppConfig) {
  return () => config.load();
}

@NgModule({
  declarations: [
    FooterComponent,
    NavbarComponent,
    LmsActivitiesProcessFlowComponent,
    ErrorModalComponent,
    LoadingIndicatorComponent,
    ContactCapDirective,
    ProgressIndicatorComponent,
    LmsConfirmationComponent.ConfirmationComponent,
  ],
  imports: [
    CommonModule,
    ProgressStoreModule,
    LoadingStoreModule,
    ClaimCmeCeStoreModule,
    StoreModule.forRoot(fromApp.appReducer),
    // AuthEffects
    EffectsModule.forRoot([LmsEffects, AuthEffects]),
    StoreDevtoolsModule.instrument(),
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    TooltipModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    NgPipesModule,
    CommonServicesModule,
    HttpClientModule,
  ],
  providers: [
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [AppConfig],
      multi: true,
    },
  ],
  exports: [
    FooterComponent,
    ErrorModalComponent,
    NavbarComponent,
    LmsActivitiesProcessFlowComponent,
    LoadingIndicatorComponent,
    ProgressIndicatorComponent,
    LmsConfirmationComponent.ConfirmationComponent,
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    TooltipModule,
    MatStepperModule,
    NgPipesModule,
    ContactCapDirective,
    CommonServicesModule,
    HttpClientModule,
  ],
})
export class SharedModule {}
